<template>
    <section class="CTALink ContentSection" :style="getBackgroundColor">
        <h1 v-html="properties.title" :style="getTitleColor"></h1>
        
        <Link :link="properties.link[0]" v-if="properties.link.length > 0" :pageData="pageData"></Link>
    </section>
</template>
<script>
import Link from '../util/Link.vue'; 

export default {
    props: ["properties", "pageData"],
    components: {
        Link
    },
    methods: {
        getRouteFromID(id) {
            return app.manifest.getRouteFromID(id);
        }
    },
    computed: {
        getTitleColor() {
            return { 'color': this.properties.usesPageColor ? '#fff' : '#000' }
        },
        getLinkArrowColor() {
            return this.properties.usesPageColor ? '#000' : getComputedStyle(document.documentElement).getPropertyValue('--secondary-color')
        },
        getBackgroundColor() {
            return { 'background-color': this.properties.usesPageColor ? this.pageData.color : getComputedStyle(document.documentElement).getPropertyValue('--light-grey') }
        }
    }
}
</script>
<style lang="scss">
.CTALink {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-top: 80px;
    padding-bottom: 80px;
    color: #fff;
    margin-top: auto;

    h1 {
        text-align: left;
        margin-bottom: 40px;
    }
}
</style>